import SearchListingFilterInput from '3-components/ListingApp/ListingFilters/SearchListingFilterInput';
import { type KeyboardEvent, type FC } from 'react';

interface SearchInputProps {
    searchQuery: string;
    setSearchQuery: (query: string) => void;
    handleOnKeyDown: (event: KeyboardEvent<HTMLInputElement>) => void;
}

const SearchInput: FC<SearchInputProps> = ({ searchQuery, setSearchQuery, handleOnKeyDown }) => {
    const inputSuffixIcon = searchQuery ? 'close' : undefined;

    const onSuffixIconClick = (): void => {
        setSearchQuery('');
    };

    return (
        <SearchListingFilterInput
            placeholder="search"
            handleOnKeyDown={handleOnKeyDown}
            inputValue={searchQuery}
            prefixIcon="search"
            suffixIcon={inputSuffixIcon}
            onSuffixIconClick={onSuffixIconClick}
            maxLength={50}
        />
    );
};

export default SearchInput;
